"use strict";

import Select from './src/select';
import Css from './src/css';
import Modal from './src/modal';
import CartShowDetailsRow from './src/cart-show-details-row';
import Emitter from './src/globalEmitter';
import ShippingOptions from './src/shippingOptions';
import Ajax from './src/ajax';
import {parentUntilAttribute} from './src/traverse';
import {init as productListPreviewsInit} from './src/productListPreviews';
import productQtyInputDisplayEstimate from './src/productQtyInputDisplayEstimate';
import {validateAddingProductForms} from './src/validateAddingProductForms';
import {gaProductListImpressions} from "./src/gaProductListImpressions";

const cartFormName = 'cart';

const lineItemQuantityInput = Select.all('[data-qty-save-input]');
const lineItemQuantitySelect = Select.all('[data-qty-save-on-change]');

ShippingOptions.init();
CartShowDetailsRow.init();

// show save button when clicking on qty input
var showSaveButtonForQtyInput = function(){
    if(lineItemQuantityInput !== null) {
        for (var i = 0, len = lineItemQuantityInput.length; i < len; i++) {
            lineItemQuantityInput[i].addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
            }, false);
            lineItemQuantityInput[i].addEventListener('focus', function (e) {
                ///e.stopPropagation();
                //reset display of inputs so only one active at a time.
                var qtySaveId = this.getAttribute('data-qty-save-input') || '';
                resetQtyInputDisplay(qtySaveId);
                var containerElement = Select.all('[data-qty-save="' + qtySaveId + '"]');
                if(containerElement !== null && containerElement.length){
                    for (var ii = 0, len2 = containerElement.length; ii < len2; ii++ )
                        Css.addClass(containerElement[ii], 'active');
                }
                var lineItemQuantityInputSubmitButton = Select.one('[data-qty-save-button="' + qtySaveId + '"]');
                lineItemQuantityInputSubmitButton.addEventListener('click', function (e) {
                    e.stopPropagation();
                    return true;
                }, false);
            }, false);
            /*lineItemQuantityInput[i].addEventListener('blur', function (e) {
                resetQtyInputDisplay();
            }, false);*/
        }
        // reset qty input display when clicking anywhere else
        var bodyContainerToResolveIOSEventListenerBugOnBody = Select.id('bodyContainerToResolveIOSEventListenerBugOnBody');

        if(bodyContainerToResolveIOSEventListenerBugOnBody !== null) {
            bodyContainerToResolveIOSEventListenerBugOnBody.addEventListener('click', function (e) {
                resetQtyInputDisplay();
            }, false);
        }
    }
};
showSaveButtonForQtyInput();

// submit form when changing qty in select elements
var submitFormWhenChangingSelectQtyEl = function(){
    if(lineItemQuantitySelect !== null) {
        for (var i = 0, len = lineItemQuantitySelect.length; i < len; i++) {
            lineItemQuantitySelect[i].addEventListener('change', function (e) {
                document.forms[cartFormName].submit();
            });
        }
    }
};
submitFormWhenChangingSelectQtyEl();

function resetQtyInputDisplay(id){
    var qtySaveId = id || '';
    var lineItemQuantityActiveElements = Select.all('.active[data-qty-save]');
    if(lineItemQuantityActiveElements !== null) {
        for (var i = 0, len = lineItemQuantityActiveElements.length; i < len; i++) {
            if (lineItemQuantityActiveElements[i].getAttribute('data-qty-save') !== qtySaveId)
                Css.removeClass(lineItemQuantityActiveElements[i], 'active');
        }
    }
}

var cartItemOptionsNotStarted = Select.one('[data-modal="cart__item__options-not-started"]');
var productKitItemModal = Select.one('[data-modal="product-kit__item"]');
var cartInterstitual = Select.one('[data-interstitial="cart-interstitial"]');

if(cartItemOptionsNotStarted !== null){
    Modal.closeOnBlur = true;
    Modal.btnCancel.callback = function(e){
        e.preventDefault();
        Modal.close(e);
    };
    Modal.init();
    Modal.setCustomContent(cartItemOptionsNotStarted.innerHTML);
    Modal.open();
} else if(productKitItemModal !== null){
    Modal.closeOnBlur = true;
    Modal.init();
    Modal.setCustomContent(productKitItemModal.innerHTML);
    Modal.open();
} else if(cartInterstitual !== null){
    if(cartInterstitual.getAttribute('data-modal')){
        var cartInterstitualId = cartInterstitual.getAttribute('data-id');
        var markInterstitualAdAsViewed = function(id=0, choice='', callback=()=>{}){
            Ajax('PUT',
                window.location.origin + '/api/v1/a-dz/interstitial/shown/' + encodeURIComponent(id),
                {choice: choice},
                function (response) {
                    var responseJson = JSON.parse(response);
                    callback();
                },
                function(status,response){
                    callback();
                }
            );
        };
        if(cartInterstitualId){
            Modal.closeOnBlur = true;
            Modal.modal.onOpenCallback = function(){
            };
            Modal.btnAccept.callback = function(e){
                e.preventDefault();
                var acceptButtonParentEl = parentUntilAttribute(e.target, 'href');
                if( acceptButtonParentEl !== null ) {
                    var acceptButtonHref = acceptButtonParentEl.getAttribute('href');
                    var acceptButtonTarget = acceptButtonParentEl.getAttribute('target');
                    markInterstitualAdAsViewed(cartInterstitualId, 'Yes', function(){
                        if(acceptButtonHref) {
                            if(!!acceptButtonTarget){
                                Modal.close(e);
                                window.open(acceptButtonHref);
                            }
                            else
                                window.location = acceptButtonHref;
                        }
                        else
                            Modal.close(e);
                    });
                }
                else
                    Modal.close(e);
            };
            Modal.btnCancel.callback = function(e){
                e.preventDefault();
                markInterstitualAdAsViewed(cartInterstitualId, 'No');
            };
            Modal.btnClose.callback = function(e){
                e.preventDefault();
                markInterstitualAdAsViewed(cartInterstitualId, 'Closed');
            };
            Modal.init();
            Modal.setCustomContent(cartInterstitual.innerHTML);
            Modal.open();
        }
    }
}

var fetchProductRecommendation = function( el ){
        if( el !== null ){
            var productId = el.getAttribute('data-recommend-product-id'),
                url = window.location.origin + '/api/v1/product/recommendation/' + encodeURIComponent( productId ),
                type = el.getAttribute('data-recommend-type'),
                idPrefix = el.getAttribute('data-recommend-id-prefix'),
                title = el.getAttribute('data-recommend-title');
            url = url + '?format=html&type=' + encodeURIComponent( type ) + '&id_prefix=' + encodeURIComponent( idPrefix ) + '&title=' + encodeURIComponent( title );

            Ajax( 'GET', url, {}, function(response){
                var parsedResponse = JSON.parse(response);
                if( parsedResponse.hasOwnProperty('data') ){
                    el.innerHTML = parsedResponse.data.html;
                    productListPreviewsInit( el );
                    productQtyInputDisplayEstimate.init( el );
                    validateAddingProductForms( el );
                    gaProductListImpressions();
                }
            }, function(){
                console.log('error');
            } );
        }
    },
    recommendationElements = Select.all('[data-recommend]');

if( recommendationElements !== null ){
    if( recommendationElements.length > 0 ){
        for( var i=0, len=recommendationElements.length ; i < len ; i++ ){
            fetchProductRecommendation( recommendationElements[i] );
        }
    }
}

Emitter.on('shipping-method-change', function (onChangeAttribute) {
    if(onChangeAttribute == 'reload')
        location.reload();
});

Emitter.on('cart-change', function (onChangeAttribute) {
        location.reload();
});

